import { PrimeVueLocaleOptions } from "primevue/config";

export default {
   "startsWith": "Begint met",
   "contains": "Bevat",
   "notContains": "Bevat niet",
   "endsWith": "Eindigt met",
   "equals": "Is gelijk aan",
   "notEquals": "Is niet gelijk aan",
   "noFilter": "Geen filter",
   "filter": "Filter",
   "lt": "Kleiner dan",
   "lte": "Kleiner dan of gelijk aan",
   "gt": "Groter dan",
   "gte": "Groter dan of gelijk aan",
   "dateIs": "Datum is",
   "dateIsNot": "Datum is niet",
   "dateBefore": "Datum is voor",
   "dateAfter": "Date is na",
   "custom": "Aangepast",
   "clear": "Wissen",
   "apply": "Toepassen",
   "matchAll": "Overeenkomen met alle",
   "matchAny": "Overeenkomen met elke",
   "addRule": "Voeg regel toe",
   "removeRule": "Verwijder regel",
   "accept": "Ja",
   "reject": "Nee",
   "choose": "Kies",
   "upload": "Upload",
   "cancel": "Annuleer",
   "completed": "Voltooid",
   "pending": "In behandeling",
   "fileSizeTypes": ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
   "dayNames": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
   "dayNamesShort": ["zon", "ma", "di", "woe", "do", "vrij", "zat"],
   "dayNamesMin": ["zo", "ma", "di", "wo", "do", "vr", "za"],
   "monthNames": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
   "monthNamesShort": ["jan", "feb", "mar", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
   "chooseYear": "Kies jaar",
   "chooseMonth": "Kies maand",
   "chooseDate": "Kies datum",
   "prevDecade": "Vorig decennium",
   "nextDecade": "Volgend decennium",
   "prevYear": "Vorig jaar",
   "nextYear": "Volgend jaar",
   "prevMonth": "Vorige maand",
   "nextMonth": "Volgende maand",
   "prevHour": "Vorig uur",
   "nextHour": "Volgend uur",
   "prevMinute": "Vorige minuut",
   "nextMinute": "Volgende minuut",
   "prevSecond": "Vorige seconde",
   "nextSecond": "Volgende seconde",
   "am": "voormiddag",
   "pm": "namiddag",
   "today": "Vandaag",
   "now": "Nu",
   "weekHeader": "Wk",
   "firstDayOfWeek": 1,
   "showMonthAfterYear": false,
   "dateFormat": "dd-mm-yy",
   "weak": "Zwak",
   "medium": "Gemiddeld",
   "strong": "Sterk",
   "passwordPrompt": "Geef een wachtwoord",
   "emptyFilterMessage": "Geen resultaten gevonden",
   "searchMessage": "{0} resultaten beschikbaar",
   "selectionMessage": "{0} opties geselecteerd",
   "emptySelectionMessage": "Geen optie geselecteerd",
   "emptySearchMessage": "Geen resultaten gevonden",
   "emptyMessage": "Geen beschikbare opties",
   "aria": {
      "trueLabel": "Waar",
      "falseLabel": "Onwaar",
      "nullLabel": "Niet geselecteerd",
      "star": "1 ster",
      "stars": "{star} sterren",
      "selectAll": "Alle opties geselecteerd",
      "unselectAll": "Alle opties gedeselecteerd",
      "close": "Sluit",
      "previous": "Vorige",
      "next": "Volgende",
      "navigation": "Navigatie",
      "scrollTop": "Scroll naar boven",
      "moveTop": "Verplaats naar boven",
      "moveUp": "Verplaats omhoog",
      "moveDown": "Verplaats omlaag",
      "moveBottom": "Verplaats naar beneden",
      "moveToTarget": "Verplaats naar doel",
      "moveToSource": "Verplaats naar bron",
      "moveAllToTarget": "Verplaats alle naar doel",
      "moveAllToSource": "Verplaats alle naar bron",
      "pageLabel": "Pagina {page}",
      "firstPageLabel": "Eerste pagina",
      "lastPageLabel": "Laatste pagina",
      "nextPageLabel": "Volgende pagina",
      "previousPageLabel": "Vorige pagina",
      "rowsPerPageLabel": "Rijen per pagina",
      "jumpToPageDropdownLabel": "Spring naar paginamenu",
      "jumpToPageInputLabel": "Spring naar pagina-invoer",
      "selectRow": "Rij geselecteerd",
      "unselectRow": "Rij gedeselecteerd",
      "expandRow": "Rij uitgeklapt",
      "collapseRow": "Rij ingeklapt",
      "showFilterMenu": "Toon filtermenu",
      "hideFilterMenu": "Verberg filtermenu",
      "filterOperator": "Filteroperator",
      "filterConstraint": "Filterbeperking",
      "editRow": "Bewerk rij",
      "saveEdit": "Sla bewerking op",
      "cancelEdit": "Annuleer bewerking",
      "listView": "Lijstweergave",
      "gridView": "Roosterweergave",
      "slide": "Dia",
      "slideNumber": "{slideNumber}",
      "zoomImage": "Zoom afbeeling",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom uit",
      "rotateRight": "Draai rechtsom",
      "rotateLeft": "Draai linksom"
   }
} as PrimeVueLocaleOptions
